// vendor
import { defineComponent, ref } from "@vue/composition-api";
// project
import * as AppModal from "@/AppModal";
import { pascalToSentenceCase } from "@/utils/text";
// local
// import AddItemContext from "../vue/add-item-context.vue";
import * as ItemTypes from "./ItemTypes";

const order:any = {
	"Information":3,
	"HTML":3,
	"LinearScale":2,
	"Answer":-1,
}


export const createComponent = () => {
	return defineComponent({

		components:{
			// AddItemContext
		},
		setup(props, context){
			// const contextMenu = ref<any>();
	
			const add = (e:Event) => {

				
				const options =  Object.keys(ItemTypes).map(k => {
					return {
						name:pascalToSentenceCase(k),
						...(ItemTypes as any)[k],
						fn(){
							confirmAdd(k)
						},
						order:order[k] || 0,
					};
				}).filter(t => !t.disabled);
				
				AppModal.context(e, options);


				// const ctx:any = contextMenu.value;
				// if(!ctx){ return; }
				// setTimeout(() => ctx.open(e, confirmAdd), 0);
			};
	
			const confirmAdd = (type:string) => {
				context.emit("add", type);
			};
	
			return {
				// contextMenu,
				add
			};
		}
	});
};